class CI {
  constructor(mathjs) {
      this.mathjs = mathjs;
  }

  bmi(weight, height) {
      return weight / (height * height);
  }

  round(number, precision, mode) {
      const fix = (mode == 'UP' ? 5 : 4) / this.mathjs.pow(10, precision + 1);
      return this.mathjs.floor(number + fix, precision);
  }

}

module.exports = CI;